import { IPreparedRouter } from '~/src/entities/speed-bonus/context/actions/setRouters';

/**
 * Способ покупки в рассрочку (duration > 0)
 */
export const isInstallment = (product: IPreparedRouter) => !!product.selectedPrice?.duration;

/**
 * Подсчитывает количество выбранных роутеров
 */
const getTotalCount = (products: IPreparedRouter[]): number => {
    return products.reduce((acc: number, curr) => acc + curr.quantity, 0);
};

/**
 * Возвращает роутеры в рассрочку
 */
const getProductsInInstallments = (products: IPreparedRouter[]) =>
    products?.filter(product => product.quantity > 0 && product.selectedPrice?.duration && product.selectedPrice.duration > 0);

/**
 * Подсчитывает количество роутеров в рассрочку
 */
const getInstalmentCount = (products: IPreparedRouter[]): number => {
    const installmentItems = getProductsInInstallments(products);
    return getTotalCount(installmentItems);
};

/**
 * Достигнут лимит на покупку роутера (всего и в рассрочку)
 */
 export const getLimits = (routers: IPreparedRouter[]) => {
    const limit = { total: 1, installment: 1 };

    const installmentCount = getInstalmentCount(routers);
    const totalCount = getTotalCount(routers);

    return {
        total: totalCount >= limit.total,
        installment: installmentCount >= limit.installment,
    };
};
